import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Control from '@/helpers/control'

@Component({
	components: {},
})
export default class TypeableDatePortal extends Vue {
	@Prop() placeholder!: string
	@Prop() initDate!: string
	@Prop() disabled!: boolean
	@Prop() invalid!: boolean
	@Prop() valid!: boolean
	@Prop() status!: string

	preventEmmitting = true
	control = new Control()

	@Watch('initDate')
	async onStateChange(newDate, oldDate) {
		if (!newDate) {
			this.model = ''
			this.modelFormatted = formatDate('')
		} else {
			this.model = newDate
			this.modelFormatted = formatDate(newDate)
		}
	}

	model = ''
	modelFormatted = ''
	mounted() {
		this.model = this.initDate || ''
		this.modelFormatted = formatDate(this.initDate || '')

		setTimeout(() => {
			this.preventEmmitting = false
		}, 0)
	}

	onContext(ctx) {
		if (ctx.selectedYMD && !this.preventEmmitting) {
			this.modelFormatted = ctx.selectedFormatted
			this.change(this.model)
		}
	}

	onDateInput(input) {
		if (input?.length === 10 || input?.length === 0) {
			this.model = unformatDate(input) || ''
			this.change(this.model)
		}
	}

	change(date) {
		const debouncedChange = this.control.debounce(this.emitChange, 10)
		debouncedChange(date)
	}

	emitChange(date) {
		this.$emit('change', date)
	}
}

function formatDate(date) {
	return date?.split('-')?.reverse()?.join('/')
}

function unformatDate(date) {
	return date?.split('/')?.reverse()?.join('-')
}
